import { useState } from "react";

import {
    obtenerComunidades,
    obtenerComunidadPublica,
    obtenerComunidadDestacados,
    crearComunidad,
    actualizarComunidad,
    eliminarComunidad,
} from "../Services/Comunidad";


// =====================================================
// ADMINISTRACIÓN
// =====================================================

export const useComunidad = () => {

    const [comunidades, setComunidades] = useState([]);
    const [comunidad, setComunidad] = useState(null);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);


    // ==========================================
    // CARGAR TODAS
    // ==========================================

    const cargarComunidades = async () => {

        try {

            setLoading(true);
            setError(null);

            const response = await obtenerComunidades();

            const data = response.data.comunidad;

            setComunidades(
                Array.isArray(data)
                    ? data
                    : data?.data || []
            );

            return response;

        } catch (error) {

            console.error(
                "Error al obtener comunidades:",
                error
            );

            setError(error);

            throw error;

        } finally {

            setLoading(false);

        }
    };


    // ==========================================
    // CREAR
    // ==========================================

    const guardarComunidad = async (formData) => {

        try {

            setLoading(true);
            setError(null);

            const response =
                await crearComunidad(formData);

            await cargarComunidades();

            return response;

        } catch (error) {

            console.error(
                "Error al crear comunidad:",
                error
            );

            setError(error);

            throw error;

        } finally {

            setLoading(false);

        }
    };


    // ==========================================
    // EDITAR
    // ==========================================

    const editarComunidad = async (
        id,
        formData
    ) => {

        try {

            setLoading(true);
            setError(null);

            const response =
                await actualizarComunidad(
                    id,
                    formData
                );

            await cargarComunidades();

            return response;

        } catch (error) {

            console.error(
                "Error al actualizar comunidad:",
                error
            );

            setError(error);

            throw error;

        } finally {

            setLoading(false);

        }
    };


    // ==========================================
    // ELIMINAR
    // ==========================================

    const borrarComunidad = async (id) => {

        try {

            setLoading(true);
            setError(null);

            const response =
                await eliminarComunidad(id);

            await cargarComunidades();

            return response;

        } catch (error) {

            console.error(
                "Error al eliminar comunidad:",
                error
            );

            setError(error);

            throw error;

        } finally {

            setLoading(false);

        }
    };


    return {

        comunidades,
        comunidad,

        loading,
        error,

        cargarComunidades,

        guardarComunidad,
        editarComunidad,
        borrarComunidad,

        setComunidad,
    };
};



// =====================================================
// COMUNIDAD PÚBLICA
// =====================================================

export const useComunidadPublica = () => {

    const [comunidades, setComunidades] =
        useState([]);

    const [loading, setLoading] =
        useState(false);

    const [error, setError] =
        useState(null);


    const cargarComunidadPublica = async () => {

        try {

            setLoading(true);
            setError(null);

            const response =
                await obtenerComunidadPublica();

            const data = response.data.comunidad;

            setComunidades(
                Array.isArray(data)
                    ? data
                    : data?.data || []
            );

            return response;

        } catch (error) {

            console.error(
                "Error al obtener comunidad pública:",
                error
            );

            setError(error);

            throw error;

        } finally {

            setLoading(false);

        }
    };


    return {

        comunidades,

        loading,
        error,

        cargarComunidadPublica,
    };
};



// =====================================================
// DESTACADOS
// =====================================================

    export const useComunidadDestacados = () => {

        const [destacados, setDestacados] =
            useState([]);

        const [loading, setLoading] =
            useState(false);

        const [error, setError] =
            useState(null);


        const cargarDestacados = async () => {

            try {

                setLoading(true);
                setError(null);

                const response =
                    await obtenerComunidadDestacados();

                const data = response.data.comunidad;

                setDestacados(
                    Array.isArray(data)
                        ? data
                        : data?.data || []
                );

                return response;

            } catch (error) {

                console.error(
                    "Error al obtener destacados:",
                    error
                );

                setError(error);

                throw error;

            } finally {

                setLoading(false);

            }
        };


        return {

            destacados,

            loading,
            error,

            cargarDestacados,
        };
    };